import { GlobalSearchListItemIcon } from './components/GlobalSearchListItemIcon'
import { GlobalSearchListItemMetadata } from './components/GlobalSearchListItemMetadata'
import { GlobalSearchListItemTitle } from './components/GlobalSearchListItemTitle'
import { GlobalSearchListItemContentStyled } from './styles/GlobalSearchListItemContentStyled'
import { GlobalSearchListItemLayoutStyled } from './styles/GlobalSearchListItemLayoutStyled'
import { type GlobalSearchResultTypeEnum } from '../../../../value-objects/enums'
import { type GlobalSearchItemMetadata } from '../../../../value-objects/GlobalSearchItemMetadata'

interface IGlobalSearchListItemProps {
  uuid: string
  type: GlobalSearchResultTypeEnum
  id: string
  label?: Nullable<string>
  metadata: GlobalSearchItemMetadata
  isHighlighted: boolean
  onClick: () => void
}

export const GlobalSearchListItem = ({
  uuid,
  type,
  id,
  label,
  metadata,
  isHighlighted,
  onClick,
}: IGlobalSearchListItemProps) => {
  return (
    <GlobalSearchListItemLayoutStyled
      id={uuid}
      role='option'
      aria-selected={isHighlighted}
      data-highlighted={isHighlighted || undefined}
      onClick={onClick}
    >
      <GlobalSearchListItemIcon type={type} />
      <GlobalSearchListItemContentStyled>
        <GlobalSearchListItemTitle type={type} id={id} label={label} />
        <GlobalSearchListItemMetadata type={type} metadata={metadata} />
      </GlobalSearchListItemContentStyled>
    </GlobalSearchListItemLayoutStyled>
  )
}
